import API from '../dataApi';

// -- Donation Categories -------------------------------------------------------
export const getParentCategories = () => API.get('/donation-category/parents');
export const getDonationCategories = (derasarId) =>
  API.get('/donation-category', { params: { derasarId } });
export const getFlatCategories = (derasarId) =>
  API.get('/donation-category/flat', { params: { derasarId } });
export const createDonationCategory = (data) => API.post('/donation-category', data);
export const updateDonationCategory = (id, data) => API.put(`/donation-category/${id}`, data);
export const getDonationCategoriesAll = (derasarId) =>
  API.get('/donation-category', { params: { derasarId, includeInactive: true } });
export const deleteDonationCategory = (id) => API.delete(`/donation-category/${id}`);
export const hardDeleteDonationCategory = (id) => API.delete(`/donation-category/${id}/permanent`);
export const reactivateDonationCategory = (id) => API.patch(`/donation-category/${id}/reactivate`);
// Parent group endpoints
export const getCategoryGroups = (derasarId) =>
  API.get('/donation-category/groups', { params: { derasarId } });
export const createCategoryGroup = (data) => API.post('/donation-category/group', data);
